import { FC } from "react";
import { useTranslation } from "react-i18next";

import { HubStationsInfoContent } from "@ryde/controls";
import {
  IHubStationsInfoDrawerProps,
  IInjectedDrawerProps,
} from "@ryde/shared";

import { CommonDefaultDrawer } from "../common-default-drawer";
import { BaseDrawer, FormFooter } from "../drawer";

export const HubStationsInfoDrawer: FC<
  IHubStationsInfoDrawerProps & IInjectedDrawerProps
> = ({ onCloseDrawer, drawerNumber }) => {
  const { t } = useTranslation();

  return (
    <BaseDrawer onCloseDrawer={onCloseDrawer} drawerNumber={drawerNumber}>
      <CommonDefaultDrawer
        title={t("hub.hubStationsInfo")}
        onCloseDrawer={onCloseDrawer}
        Footer={
          <FormFooter
            cancelLabel={t("general.CLOSE")}
            onCancelClick={onCloseDrawer}
          />
        }
      >
        <HubStationsInfoContent />
      </CommonDefaultDrawer>
    </BaseDrawer>
  );
};
